// extracted by mini-css-extract-plugin
module.exports = {"startup_card":"cohortStartups_startup_card__3LsjB","greenDot":"cohortStartups_greenDot__2egZK","cohortCrumb":"cohortStartups_cohortCrumb__1RPiS"};